// Egyptian Gateway
export const environmentURL: string =
  "https://api.preprod.invoicing.eta.gov.eg";

export const EG_INVOICING_TOKEN: string = `https://id.preprod.eta.gov.eg/connect/token`;
export const EG_SUBMIT_DOCUMENT: string = `${environmentURL}/api/v1.0/documentsubmissions`;
export const EG_CANCEL_DOCUMENT: string = `${environmentURL}/api/v1.0/documents/state/`;

// Lambda Function
export const EG_SEND_INVOICE: string =
  "https://pjyfkfrgud7rww2fhqjxxx4jse0yrgwf.lambda-url.us-east-2.on.aws/";

export enum EG_OPERATIONS {
  INVOICE = "invoice",
  CANCEL_INVOICE = "cancelInvoice",
  CANCEL_INVOICE_LINE = "cancelInvoiceLine",
  SUBMIT_INVOICE = "submitInvoice",
  RESUBMIT_INVOICE = "resubmitInvoice",
  RECEIPT = "receipt",
  CREDIT_NOTE = "creditNote",
}

/** Lambda Function URL for sendInvoiceZatca (HTTPS + invoker Basic auth; use {@link ZATCA_INTEGRATION_AUTHORIZATION}). */
export const ZATCA_SEND_INVOICE_LAMBDA_URL =
  "https://esbkqf5j5hxqu4zpeqkxkw4gwa0hztaj.lambda-url.us-east-2.on.aws";

/** Full `Authorization` header value for the ZATCA Lambda Function URL (Basic invoker credentials). */
export const ZATCA_INTEGRATION_AUTHORIZATION =
  "Basic aHJzOmhyc0AyMDI1MTIz";

// export const testingCancelZatcaEndPoint =
//   "https://.../?branchId=...&operation=creditNote&env=test&type=simphony";

export const createZatcaEndpoint = ({
  branchId,
  operation,
  env,
  type,
  creditNoteOnly,
}: {
  branchId: string;
  operation: string;
  env: string;
  type?: string;
  creditNoteOnly?: boolean;
}) => {
  const base = ZATCA_SEND_INVOICE_LAMBDA_URL.replace(/\/$/, "");
  const typeHasValue =
    type !== undefined &&
    type !== null &&
    String(type).trim() !== "";
  const typePart = typeHasValue
    ? `&type=${encodeURIComponent(String(type).trim())}`
    : "";
  const cnPart = creditNoteOnly === true ? "&creditNoteOnly=true" : "";
  return `${base}/?branchId=${encodeURIComponent(
    String(branchId)
  )}&operation=${encodeURIComponent(
    operation
  )}&env=${encodeURIComponent(String(env))}${typePart}${cnPart}`;
};
